export default {
  // App Bar Actions
  app_bar_actions: {
    account_menu: {
      tooltip: "Детали за профилот",

      // Account Menu Card
      account_menu_card: {
        // Language Section
        language_section: {
          title: "Избирање на јазик",
          tooltip: "Избирање на преферирани јазик",

          languages: {
            en: "Англиски",
            bg: "Бугарски",
            mk: "Македонски",
          },
        },

        // Theme Section
        theme_section: {
          title: "Избирање на тема",
          tooltip: "Избирање на тема на апликацијата",

          themes: {
            light: "Светла",
            dark: "Темна",
            auto: "Системска",
          },
        },

        // Sign Out
        sign_out: {
          title: "Одјава",
          tooltip: "Одјавување од апликацијата",
        },
      },
    },
  },

  // Drawer Toggle
  drawer_toggle: {
    open_tooltip: "Отворање на мени",
    rail_tooltip: "Проширување на мени",
    close_tooltip: "Затворање на мени",
  },

  // Page Titles
  page_titles: {
    channels: "Канали",
    validation: "Валидација",
    about: "За апликацијата",
    login: "Најава",
  },
};
